/** The theme to show: the saved one when it is offered, otherwise the default. The saved value itself is never changed. */
export function effectiveTheme(saved: string, enabled: readonly string[], fallback: string): string {
  return enabled.includes(saved) ? saved : fallback;
}
